import { BlacklistRequest } from './blacklist';

export const defaultLimit = 10;

export class DefaultParams implements BlacklistRequest {
  limit = defaultLimit;
  page = 1;
}
